// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { useColumnWidths } from '../use-column-widths';
import { getColumnKey } from '../utils';
/*
 * Renders a <colgroup> with <col> elements for each column.
 * With table-layout:fixed, <col> widths control actual column widths,
 * which makes colspan headers automatically span the correct width.
 * Must be rendered inside ColumnWidthsProvider.
 */
export function TableColGroup({ visibleColumnDefinitions, hasSelection, sticky = false, selectionColumnId, }) {
    const { getColumnStyles, setCol } = useColumnWidths();
    return (React.createElement("colgroup", null,
        hasSelection && (React.createElement("col", { style: sticky ? { width: getColumnStyles(true, selectionColumnId).width } : undefined, ref: node => setCol(sticky, selectionColumnId, node) })),
        visibleColumnDefinitions.map((column, colIndex) => {
            const columnId = getColumnKey(column, colIndex);
            if (sticky) {
                return (React.createElement("col", { key: String(columnId), style: { width: getColumnStyles(true, columnId).width }, ref: node => setCol(true, columnId, node) }));
            }
            return React.createElement("col", { key: columnId, "data-column-id": String(columnId), ref: node => setCol(false, columnId, node) });
        })));
}
//# sourceMappingURL=col-group.js.map